export const getElectricityConsumption = (
  specificIndirectEmbeddedEmissions: number,
  electricityEmissionFactor: number
) => {
  return specificIndirectEmbeddedEmissions / electricityEmissionFactor
}
